import React, { Suspense, lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AppLoader from './AppLoader';
const LoginPage = lazy(() => import('pages/Login/LoginPage'));
const ForgotPasswordPage = lazy(() => import('pages/Login/ForgotPasswordPage'));
const Dashboard = lazy(() => import('pages/dashboard/Dashboard'));
const PrivateRoute = lazy(() => import('./PrivateRoute'));

function AppRouting() {
  return (
    <Suspense fallback={<AppLoader />}>
      <Switch>
        <Route exact path="/login">
          <LoginPage />
        </Route>
        <Route exact path="/forgot-password">
          <ForgotPasswordPage />
        </Route>
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
        <Redirect to="/" />
      </Switch>
    </Suspense>
  );
}

export default AppRouting;
